const teamData = [
  {
    name: "Rajveer Sanghavi",
    position: "Convenor",
    team: "Convenor",
    facebook: "",
    twitter: "",
    github: "https://github.com/Pegasus167",
    linkedin: "https://www.linkedin.com/in/rajveer-sanghavi-71a4561b2",
    instagram: "https://instagram.com/rajveersanghavi?igshid=ZDc4ODBmNjlmNQ==",
    image:
      "",
  },
  {
    name: "Vedant Nemade",
    position: "Lead",
    team: "Sponsorship and Finance",
    facebook: "",
    twitter: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/vedant-nemade-850013232",
    instagram: "https://instagram.com/_vedant_nemade_?igshid=MjEwN2IyYWYwYw==",
    image:
      "https://images.prismic.io/swj23/8215f816-4c27-4b29-a2c4-5cd10d611563_Vedant_Nemade_Sponsorship_and_Finance_Lead.jpg?auto=compress,format&w=500&h=500",
  },
  {
    name: "Nayonika Sharma",
    position: "Lead",
    team: "Social Media",
    facebook: "",
    twitter: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/nayonika-sharma-809626242",
    instagram: "https://instagram.com/nayonikaaaa?igshid=MmIzYWVlNDQ5Yg==",
    image:
      "https://images.prismic.io/swj23/65813c3a-c3d2-48a2-b56c-846792e68087_Nayonika+Sharma_Social+Media_Lead.jpg?auto=compress,format&w=500&h=500",
  },
  {
    name: "Aastha Tandon",
    position: "Co-Lead",
    team: "Social Media",
    facebook: "",
    twitter: "",
    github: "",
    linkedin: "",
    instagram: "https://instagram.com/_aasthaaaaaa_?igshid=MzRlODBiNWFlZA==",
    image:
      "https://images.prismic.io/swj23/ca059751-41d0-4454-bf2c-23aa1ec1138c_Aastha+Tandon_Social+Media_Co+lead.jpg?auto=compress,format&w=500&h=500",
  },
  {
    name: "Dev Shalinkumar Agrawal",
    position: "Co-Lead",
    team: "Event Productions",
    facebook: "",
    twitter: "https://twitter.com/devagra20546748?t=Xh_tTtV_DkcFPvA95HcQ-w&s=08",
    github: "https://github.com/devagra28",
    linkedin: "https://www.linkedin.com/in/dev-agrawal28",
    instagram: "https://instagram.com/dev_agrawal28?igshid=MzNlNGNkZWQ4Mg==",
    image:
      "",
  },
 
  {
    name: "Samarth Bagga",
    position: "Co-Lead",
    team: "Web Development",
    facebook: "",
    twitter: "",
    github: "",
    linkedin: "",
    instagram: "",
    image:
      "",
  },
  {
    name: "Ansh Srivastava",
    position: "Co-Lead",
    team: "Sponsorship and Finance",
    facebook: "https://www.facebook.com/ansh.srivastava.752",
    twitter: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/ansh-srivastava-60a082193/",
    instagram: "https://www.instagram.com/ansh_srivastava_7755/",
    image:
      "https://images.prismic.io/swj23/f82c0d36-ff84-40ad-b836-18fe1507796a_ANSH_SRIVASTAVA%28co-lead+for+sponsorship%29.jpg?auto=compress,format&w=500&h=500",
  },
  {
    name: "Divya Srivastva",
    position: "Lead",
    team: "Event Production",
    facebook: "",
    twitter: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/divya-srivastva",
    instagram: "https://instagram.com/_divyaaa_14?igshid=MzNlNGNkZWQ4Mg==",
    image:
      "",
  },
  {
    name: "Manya Goel",
    position: "Co-Lead",
    team: "Content",
    facebook: "https://www.facebook.com/profile.php?id=100074625557118&mibextid=ZbWKwL",
    twitter: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/manya-goel-8a6335222",
    instagram: "https://instagram.com/manya_3110?igshid=MzNlNGNkZWQ4Mg==",
    image:
      "",
  },
  {
    name: "Abhimanyu Bhasin",
    position: "Co-Lead",
    team: "Marketing",
    facebook: "",
    twitter: "",
    github: "",
    linkedin: "",
    instagram: "https://instagram.com/abhi_bhasin.16?igshid=MmIzYWVlNDQ5Yg==",
    image:
      "https://images.prismic.io/swj23/3fa11712-2bf6-4f07-a508-2eaf87a59f17_Abhimanyu+Bhasin+%28marketing+co+lead%29.jpg?auto=compress,format&w=500&h=500",
  },
  {
    name: "Archie Agrawal",
    position: "Co-Lead",
    team: "Marketing",
    facebook: "",
    twitter: "",
    github: "",
    linkedin: "",
    instagram: "https://instagram.com/archiee__.26?igshid=MjEwN2IyYWYwYw==",
    image:
      "",
  },
  {
    name: "Dhruv Bansal",
    position: "Co-Lead",
    team: "Media",
    facebook: "",
    twitter: "",
    github: "https://github.com/Dhruvbansal2804",
    linkedin: "https://www.linkedin.com/in/dhruv-bansal-29b00a168/",
    instagram: "https://instagram.com/dhruvbansal28?igshid=NGExMmI2YTkyZg==",
    image:
      "https://images.prismic.io/swj23/0bbe391c-3b12-4fed-82b5-6d4d4cbd0d59_Dhruv+Bansal_media_colead.jpg?auto=compress,format&w=500&h=500",
  },
  {
    name: "Mohit Yadav",
    position: "Co-Lead",
    team: "Media",
    facebook: "https://www.facebook.com/profile.php?id=100043141874792",
    twitter: "https://www.twitter.com/mohit_ydv21",
    github: "",
    linkedin: "https://www.linkedin.com/in/mohit-yadav-9680ab226",
    instagram: "https://www.instagram.com/mohit_ydv21/?igshid=YmMyMTA2M2Y%3D",
    image:
      "https://images.prismic.io/swj23/fab68a50-7697-461d-afea-a9ccc666449e_Mohit+Yadav_Media+and+Coverage_Co+lead.jpeg?auto=compress,format&w=500&h=500",
  },
  {
    name: "Atul Raj Sharma",
    position: "Convenor",
    team: "Convenor",
    facebook: "https://www.facebook.com/profile.php?id=100076281927561&mibextid=ZbWKwL",
    twitter: "https://twitter.com/AtulSHA3025721?t=da_PPqu-h-DHin9o6-ExoA&s=09",
    github: "https://github.com/atulrajsh30?tab=overview&from=2023-05-01&to=2023-05-31",
    linkedin: "https://www.linkedin.com/in/atul-raj-sharma-610361221",
    instagram: "https://www.instagram.com/invites/contact/?i=1q5wa6yta1k55&utm_content=3dx6dym",
    image:
      "",
  },
  {
    name: "Aditya Joshi",
    position: "Co-Lead",
    team: "Event Productions",
    facebook: "",
    twitter: "https://twitter.com/aditya__exe",
    github: "https://github.com/adityajoshi-08",
    linkedin: "",
    instagram: "",
    image:
      "https://images.prismic.io/swj23/5d4a1f64-c8ce-483f-8a20-0594b967ef89_Aditya+Joshi+%28Event+Productions+Co-Lead%29.JPG?auto=compress,format&w=500&h=500",
  },
  {
    name: "Aaron Sequeira",
    position: "Lead",
    team: "Event Operations",
    facebook: "https://www.facebook.com/aaron.sequeira.984",
    twitter: "https://twitter.com/1234_sequeira",
    github: "https://github.com/aaronseq12/aaronseq12",
    linkedin: "https://www.linkedin.com/in/aaron-sequeira-987874226/",
    instagram: "https://www.instagram.com/aaron.seq/?hl=en",
    image:
      "https://images.prismic.io/swj23/9233e08f-c2f4-4129-87df-4f541e4f8357_Aaron+Sequeira+%28Event+Operation+lead%29.jpg?auto=compress,format&w=500&h=500",
  },
  {
    name: "Vitika Vora",
    position: "Co-Lead",
    team: "Design",
    facebook: "",
    twitter: "https://twitter.com/Vitikavora?t=L35tCh7d1v9y7hkv1lTuNg&s=09",
    github: "https://github.com/Vitikavora09",
    linkedin: "https://www.linkedin.com/in/vitika-vora-788823247",
    instagram: "https://instagram.com/vitikkaaa?igshid=MzNlNGNkZWQ4Mg==",
    image:
      "",
  },
  {
    name: "Anmol Singh Gill",
    position: "Co-Lead",
    team: "Social Media",
    facebook: "",
    twitter: "",
    github: "https://github.com/anm0lgill",
    linkedin: "https://www.linkedin.com/in/anmol-singh-gill-247506224/",
    instagram: "https://www.instagram.com/anmol._gill/",
    image:
      "https://images.prismic.io/swj23/5f75f2dc-85f2-4c3b-9a71-5b18a3a9e78f_Anmol+Singh+Gill_Social+Media_Co+lead.jpg?auto=compress,format&w=500&h=500",
  },
  {
    name: "Nishita Gogia",
    position: "Co-Lead",
    team: "Curations and Hospitality",
    facebook: "",
    twitter: "https://twitter.com/itsnishita17",
    github: "",
    linkedin: "https://www.linkedin.com/in/nishita-gogia-52b205239",
    instagram: "https://www.instagram.com/nishita.gogia/#",
    image:
      "",
  },
  {
    name: "Nachiketa Jha",
    position: "Co-Lead",
    team: "Operations",
    facebook: "",
    twitter: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/nachiketa-jha-416701220",
    instagram: "https://instagram.com/__nachiketa._?igshid=MzNlNGNkZWQ4Mg==",
    image:
      "",
  },
  {
    name: "Shrija Banerjee",
    position: "Lead",
    team: "Promotions",
    facebook: "",
    twitter: "",
    github: "",
    linkedin: "https://www.linkedin.com/mwlite/in/shrija-banerjee-5a3399250",
    instagram: "https://www.instagram.com/irrelevant.shrija/?next=%2F",
    image:
      "",
  },
  {
    name: "Pratyaksh Singhal",
    position: "Lead",
    team: "Curations and Hospitality",
    facebook: "",
    twitter: "",
    github: "",
    linkedin: "",
    instagram: "https://instagram.com/_pratyaksh_001_?igshid=ZGUzMzM3NWJiOQ==",
    image:
      "https://images.prismic.io/swj23/860b3008-f539-4d81-bc5e-5625b9336aa8_Pratyaksh+Singhal_hospitality_Curations_Lead.jpg?auto=compress,format&w=500&h=500",
  },
  {
    name: "Shubham Garg",
    position: "Co-Lead",
    team: "Web Development",
    facebook: "",
    twitter: "https://twitter.com/shubhamistic",
    github: "https://github.com/shubhamistic",
    linkedin: "https://www.linkedin.com/in/shubhamistic/",
    instagram: "https://www.instagram.com/geekshubham/",
    image:
      "",
  },
  {
    name: "Bhavya Bhardwaj",
    position: "Co-Lead",
    team: "Media",
    facebook: "",
    twitter: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/bhavya-bhardwaj-7119b2204",
    instagram: "",
    image:
      "https://images.prismic.io/swj23/ab919c41-855c-4088-ac60-f992f9206633_Bhavya+Bhardwaj_Coverage_Media_Colead_.jpg?auto=compress,format&w=500&h=500",
  },
  {
    name: "Anushka Saxena",
    position: "Co-Lead",
    team: "Event Operations",
    facebook: "",
    twitter: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/anushka-saxena-777201196",
    instagram: "https://instagram.com/anushkaa.saxena?igshid=MmIzYWVlNDQ5Yg==",
    image:
      "",
  },
  {
    name: "Manan Tola",
    position: "Lead",
    team: "Media",
    facebook: "",
    twitter: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/manantola",
    instagram: "https://instagram.com/drownedincaffeine?igshid=MzNlNGNkZWQ4Mg==",
    image:
      "",
  },
  {
    name: "Kunal Singh Chauhan ",
    position: "Co-Lead",
    team: "Curations and Hospitality",
    facebook: "",
    twitter: "https://twitter.com/KunalSingh8306?t=tC4usg3DJMpEMOW1XtqnyQ&s=09",
    github: "https://github.com/kunal-singh-chauhan",
    linkedin: "https://www.linkedin.com/in/kunal-singh-chauhan-245105241",
    instagram: "https://instagram.com/kunalalive?igshid=MzNlNGNkZWQ4Mg==",
    image:
      "https://images.prismic.io/swj23/4a20ca6f-ba61-4bba-877e-134b10e285f1_Kunal_Singh_Chauhan_Curations_Hospitality_co-lead.jpg?auto=compress,format&w=500&h=500",
  },
  {
    name: "Shreya Singh",
    position: "Co-Lead",
    team: "Coverage",
    facebook: "",
    twitter: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/shreya-singh-bb7b18267",
    instagram: "https://instagram.com/_shreya.xx_?igshid=MzRlODBiNWFlZA==",
    image:
      "",
  },
];

export default teamData;
